import "chatnext-ui/dist/index";

const changeRoute = (route) => {
    window.location.href = route;
}

window.nativeInterface.registerInterfacingFunction('changeRoute', changeRoute);
